<template>
  <v-form ref="form">
    <v-flex class="pb-16">
      <text-field
        v-model.trim="form.firstName"
        label="First name"
        :validator="vs.form.firstName"
      />
    </v-flex>
    <v-flex class="pb-16">
      <text-field
        v-model.trim="form.lastName"
        label="Last name"
        :validator="vs.form.lastName"
      />
    </v-flex>
    <v-flex class="pb-16">
      <text-field
        v-model.trim="form.email"
        label="Email"
        :validator="vs.form.email"
      />
    </v-flex>
    <v-flex class="pb-16">
      <text-field
        v-model.trim="form.eventQuota"
        :validator="vs.form.eventQuota"
        :error-messages="{ minValue: 'Minimum quota is 1'}"
        label="Event Quota"
        type="number"
      />
    </v-flex>
  </v-form>
</template>

<script>

export default {
  props: {
    vs: {
      type: Object,
      default: () => {},
    },
    reset: {
      type: Boolean,
      default: false,
    },
    initialValues: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: this.initialValues,
    }
  },
  watch: {
    form(val) {
      this.$emit('values', val)
    },
    reset(val) {
      if (val) {
        this.form = { eventQuota: 1 }
        this.vs.$reset()
        this.$emit('update:reset', !val)
      }
    },
  },
}
</script>

<style>

</style>
